import Select from 'components/FormComponents/Select/Select'
import { SelectionTypes } from '../../lib/enums'
import { Row } from '@tanstack/react-table'

const EditableSelectCell = ({
    selectId,
    selectionType,
    value,
    row,
    column: { id },
    updateMyData,
    options,
    isDisabled,
    inputCreator
}: EditableSelectCellProps) => {
    const handleInputChange = value => {

        if (!updateMyData) {
            return
        }

        //assure that the selection value returned is a number for all the select component used in the React table.
        let selectionValue = value;
        if (selectionType && selectionType === SelectionTypes.Number && !isNaN(value)) {
            selectionValue = parseInt(value);
        }

        if (inputCreator) {
            updateMyData(row, id, inputCreator(selectionValue))
        } else {
            updateMyData(row, id, selectionValue)
        }
    }

    return <Select
        id={selectId}
        options={options}
        handleDataChange={handleInputChange}
        isSmall initialValue={value}
        isDisabled={isDisabled}
        className="msds-selects" />
}

export default EditableSelectCell

type EditableSelectCellProps = {
    selectId?: string;
    selectionType: SelectionTypes
    value?: string
    row
    column: { id: string }
    updateMyData?: (row: Row<any>, columId: string, value: string) => void
    isDisabled?: boolean
    options: { label: string; value: string | number }[]
    inputCreator?: (inputValue: string) => any;
}
